<template>
  <form @submit.prevent="formSubmit">
    <div class="form-group">
      <label>{{ $t('lang.forms.email') }}</label>
      <input
        v-model="formData.email"
        type="email"
        class="form-control"
        name="email"
        required
      >
      <i class="icon_mail_alt" />
    </div>

    <div class="form-group">
      <label>{{ $t('lang.forms.password') }}</label>
      <input
        id="password"
        v-model="formData.password"
        class="form-control password-input"
        :type="showPassword ? 'text' : 'password'"
        name="password"
        required
      >

      <i class="icon_lock_alt" />
      <button
        type="button"
        class="password-toggle"
        :aria-label="passwordVisibilityLabel(showPassword)"
        :aria-pressed="showPassword"
        @click="showPassword = !showPassword"
      >
        <span :class="showPassword ? 'icon-eye-off' : 'icon-eye'" />
      </button>
    </div>

    <Errors :errors="errors" />

    <button
      type="submit"
      class="btn_1 btn_secondary full-width mt-4"
      :disabled="validated"
    >
      <span v-if="validated"><i
        class="icon-spin6 animate-spin"
        style="font-size: 130%"
      /></span>
      <span v-else>{{ $t('lang.titles.singin') }}</span>
    </button>
  </form>
</template>

<script>
import { API, errorResponse } from '../../api/api';
import Errors from '../Alerts/Errors';

const AuthAPI = API.get('auth');

export default {
  name: 'Login',
  components: {
    Errors,
  },

  data() {
    return {
      formData: {
        email: '',
        password: '',
        uuid: this.$store.state.main.uuid,
      },

      errors: {},
      validated: false,
      showPassword: false,
    };
  },

  methods: {

    passwordVisibilityLabel(isVisible) {
      return this.$t(isVisible ? 'lang.forms.hide_password' : 'lang.forms.show_password');
    },

    // @vuese
    // Submit form data to server
    async formSubmit(e) {
      e.preventDefault();

      this.errors = {};
      this.validated = true;

      try {
        const { data } = await AuthAPI.logIn(this.formData);
        this.$emit('authenticatedUser', data, 'login');
      } catch (error) {
        this.errors = errorResponse(error);
        this.validated = false;
      }
    },
  },
};

</script>
